import cryptoJS from 'crypto-js';
import { Buffer } from 'buffer';
import CryptoJS from 'crypto-js';

// Importacion de librerias decodificaion de token
import { isExpired, decodeToken } from "react-jwt";
import { VencimientoToken } from '../API/IT/Users/UserRequests';


const algorithm = 'aes-256-ctr';
const password = 'd6F3Efeq';


export let tiempoToken = new Date();
localStorage.setItem(process.env.REACT_APP_StorageTokenTiempo, new Date());

export const encrypt = (text) => {
    // TODO CAMBIAR createCipher por otro
    const encrypted = cryptoJS.AES.encrypt(text, password).toString();
    return encrypted;
}

//TODO VER DONDE SE UTILIZA PARA ELIMINARLO
export const decrypt = (text) => {
    const decrypted = cryptoJS.AES.encrypt(algorithm, password);
    return decrypted;
}

export const verifyToken = (token) => {
    // console.log('Verificando Token', token);
    if(token){
    const old = localStorage.getItem(process.env.REACT_APP_StorageToken);
    const user = JSON.parse(localStorage.getItem(process.env.REACT_APP_StorageUser));
    const decrypted = decodeToken(token);
    if (token !== old && user?.idUser === decrypted.idUser) {
        localStorage.setItem(process.env.REACT_APP_StorageToken, token);
        tiempoToken = new Date();
        console.log('Token Cambio')
        localStorage.setItem(process.env.REACT_APP_StorageTokenTiempo, new Date());
    } else {
        // console.log('no cambio');
    }
}
}

// Cierre de Sesion y redireccion a Login
export const handleLogout = async () => {
    localStorage.removeItem('ultimaUrl');
    const ppfToken = localStorage.getItem(process.env.REACT_APP_StorageToken);
    const decoded = decodeToken(ppfToken);
    if (!isExpired(ppfToken)) {
        VencimientoToken(decoded.idUser);
    }
    // TODO CAMBIAR POR INDEXED DB
    localStorage.removeItem(process.env.REACT_APP_StorageTokenTiempo);
    localStorage.removeItem(process.env.REACT_APP_StorageTokenDieTiempo);
    localStorage.removeItem(process.env.REACT_APP_StorageToken);
    localStorage.removeItem(0);
    localStorage.removeItem(1);
    localStorage.removeItem(2);
    localStorage.removeItem(process.env.REACT_APP_StorageToken);
    window.localStorage.removeItem(process.env.REACT_APP_StorageToken);
    localStorage.removeItem(process.env.REACT_APP_StorageToken, null);
    localStorage.removeItem(process.env.REACT_APP_StorageUser, null);
    localStorage.removeItem(process.env.REACT_APP_StorageTokenTiempo, null);
    localStorage.removeItem(process.env.REACT_APP_StorageTokenDieTiempo, null);
    window.location.href = window.location.origin + `${process.env.REACT_APP_ENV}/home`;
}

export const validarRespuesta = (res) => {
    // console.log(res.token);
    if ( (res?.token && (isExpired(res.token))) || res.auth === false) {
        handleLogout();
    } else {
        verifyToken(res?.token);
    }
}




export const encryptorSymmetric = async (value, key) => {
    const iv = window.crypto.getRandomValues(new Uint8Array(12)); // IV de 96 bits
    const mensaje = new TextEncoder().encode('¡Hola, mundo!');
    const encrypt = await window.crypto.subtle.encrypt(
        {
            name: 'AES-GCM',
            iv: iv,
        },
        key,
        mensaje
    )
    return { encrypt: Buffer.from(encrypt).toString('base64'), iv: Buffer.from(iv).toString('base64') }
}

export const decryptorSymetric = async (key, data) => {
    const decrypted = await window.crypto.subtle.decrypt(
        {
            name: 'AES-GCM',
            iv: Buffer.from(data.iv, 'base64'),
        },
        key,
        Buffer.from(data.encrypt, 'base64')
    )
    return Buffer.from(decrypted).toString('utf-8');
}


export const decryptData = (key,data) => {
    const EncryptedData = {
        iv: data.iv,
        ciphertext: CryptoJS.enc.Base64.parse(data.cifrado),
        tag: CryptoJS.enc.Hex.parse(data.tag)
      };

    const decryptedBytes = CryptoJS.AES.decrypt(
      {
        ciphertext: EncryptedData.ciphertext,
        salt: ''
      },
      CryptoJS.enc.Utf8.parse(key),
      {
        iv: CryptoJS.enc.Hex.parse(EncryptedData.iv),
        tag: CryptoJS.enc.Hex.parse(EncryptedData.tag),
        format: CryptoJS.format.OpenSSL
      }
    );

    console.log(decryptedBytes.toString(CryptoJS.enc.Utf8));
}